import { useState } from 'react'
import { ValueNarrative } from '../../queries/useGetValueNarrativesQuery'

const useValueNarrativeModal = () => {
    const [valueNarrative, setValueNarrative] = useState<ValueNarrative | null>(null)

    const isOpen = valueNarrative !== null

    const handleClose = () => {
        setValueNarrative(null)
    }

    const handleOpen = (valueNarrative: ValueNarrative) => {
        setValueNarrative(valueNarrative)
    }

    return {
        isOpen,
        handleOpen,
        handleClose,
        valueNarrative,
    }
}

export default useValueNarrativeModal
